<template>
<div>
    <v-toolbar flat color="white" pt-4 mt-4>
      <v-spacer></v-spacer>
      <v-text-field label="Search" v-model="search"></v-text-field>
        <v-btn round color="primary" @click="addModuleModal=true">
            Add Module
        </v-btn>
    </v-toolbar>
    <v-data-table
        :headers="headers"
        class="elevation-1"
        :items="modules"
        :search="search"
        :rows-per-page-items="[25, 50, 100, 250]"
        v-model="selected"
        item-key="id"
        align-center
        style="cursor: pointer"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
              <v-icon small @click="editItem(props.item)">edit</v-icon>
            <v-icon small @click="deleteItem(props.item)">delete</v-icon>
          </td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.name}}</td>
           <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.description}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>

      <v-dialog v-model="addModuleModal" max-width="750px">
          <v-card flat color="white">
              <v-toolbar color="primary"><h1 class="headline white--text">ADD MODULE</h1></v-toolbar>
              <v-card-text>
                  <v-text-field label="Module Name" v-model="item.name"></v-text-field>
                  <v-text-field label="Description" v-model="item.description"></v-text-field>
              </v-card-text>
              <v-card-actions>
                  <v-layout justify-center>
                      <v-btn round color="primary" @click="addModuleModal=false">Cancel</v-btn>
                      <v-btn round color="primary" @click="saveModule">Save</v-btn>
                  </v-layout>
              </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog v-model="editModuleModal" max-width="750px">
        <v-card flat color="white">
          <v-toolbar color="primary"><h1 class="headline white--text">EDIT MODULE: {{item.name}}</h1></v-toolbar>
          <v-text-field v-model="item.name" label="Name"></v-text-field>
          <v-text-field v-model="item.description" label="URL"></v-text-field>
          <v-card-actions>
          <v-layout justify-center>
            <v-btn round colour="gluePrimary" @click="editModuleModal=false">Cancel</v-btn>
            <v-btn round colour="gluePrimary" @click="saveEditedModule">Save</v-btn>
          </v-layout>
        </v-card-actions>

        </v-card>
        

      </v-dialog>
</div>


  
</template>

<script>
import Api from "@/services/Api";
export default {
    data(){
        return {
            addModuleModal:false,
            selected: [],
            item: {},
            editModuleModal: false,
            modules: [],
            search: '',
            headers: [
                {
          text: "Action",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        }]
        }
    },
    created(){
        this.getModules()
    },
    methods: {
        getModules(){
            Api()
            .get('/modules')
            .then(response=>{
                this.modules=response.data
            })
        },
        editItem(item){
            this.item = Object.assign({}, item);
            this.editModuleModal=true
        },
        saveEditedModule(item){
          Api()
            .put('/modules/'+this.item.id,{
                name: this.item.name,
                description: this.item.description,
                isActive: true,
                isDelete: false
            }).then(this.editModuleModal=false, this.item={}, this.getModules())
        },
        deleteItem(item){
            Api()
            .put('/modules/'+item.id,{
                isActive: false,
                isDeleted: true
            }).then(this.getModules())
        },
        saveModule(){
            Api()
            .post('/modules',{
                name: this.item.name,
                description: this.item.description,
                isActive: true,
                isDelete: false
            }).then(this.addModuleModal=false, this.item={}, this.getModules())
        },
        routerLinkToDetails(item) {
      this.$router.push({ path: "/modules/" + item.id });
  
    },
    }

}
</script>

<style>

</style>